import gql from 'graphql-tag';

export const QUERY_GET_REMOTE_CONFIG_ENTRY = gql`
  query RemoteConfigEntry($key: String!) {
    remoteConfigEntry(key: $key) {
      key
      value
    }
  }
`;

export const queryRemoteConfigEntry = async (client, key, callbackFn) => {
  try {
    const { data } = await client.query({
      query: QUERY_GET_REMOTE_CONFIG_ENTRY,
      variables: { key }
    });
    const result = data.remoteConfigEntry?.value;
    if (callbackFn) {
      callbackFn(result);
    }
    return result;
  } catch (e) {
    console.error('queryRemoteConfigEntry exception?', e);
  }
};
